module.exports = require("typedarray-to-buffer");